
var sockets = {
    receive_one: function (data) {
        this.$store.dispatch('act_push_message', data);
    },
    receive_more: function (data) {
        //console.log(JSON.stringify(data));
        for(var i=0; i<data.length; i++){
            this.$store.dispatch('act_push_message', data[i]);
        }
    },
    receive_all: function (data) {
        //太消耗性能--> 后续慢慢放弃掉
        console.log(JSON.stringify(data));
    },

    connect: function () {
        var socket_id = this.$socket.id;
        this.$store.commit('set_socket_id', socket_id);
    },
    connecting() {
        console.log('正在连接...');
    },
    connect_failed() {
        console.log('连接失败！');
    },
    error() {
        console.log('socket连接出错了');
    },
    reconnecting() {
        console.log('正在重连...');
    },
    reconnect() {
        console.log('重连成功！');
    },
    reconnect_failed() {
        console.log('重连失败！');
    },
    disconnect() {
        console.log('断开连接!');
        this.$store.commit('set_socket_id', '');
        this.$store.commit('set_socket_login', false);
    }
}

export default sockets